import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: 'Ab wann hat Katrin eine Verbesserung bemerkt?',
    a: 'Bereits nach 7–10 Tagen zeigte Felix deutliche Verbesserungen. Bei manchen Hunden dauert es etwas länger — bis zu 3 Wochen.'
  }, {
    q: 'Ist das Topping auch für empfindliche Hunde geeignet?',
    a: 'Ja — das Topping enthält keine Zusatzstoffe, keine künstlichen Aromen und ist speziell für Hunde mit empfindlichem Magen entwickelt.'
  }, {
    q: 'Wie viel gibt man täglich?',
    a: 'Die empfohlene Menge steht auf der Verpackung und richtet sich nach dem Körpergewicht des Hundes. Katrin hat mit der kleinsten Menge angefangen und langsam gesteigert.'
  }, {
    q: 'Was wenn es bei meinem Hund nicht wirkt?',
    a: 'Hunderunde bietet eine Zufriedenheitsgarantie. Falls du keine Verbesserung siehst, kannst du dich direkt an den Kundenservice wenden.'
  }];
  return <section className="w-full py-16 px-4 md:px-8 bg-cream" data-id="element-82">
      <div className="max-w-3xl mx-auto" data-id="element-83">
        <h2 className="font-handwritten text-4xl md:text-5xl text-center text-forestGreen font-bold mb-10" data-id="element-84">
          Häufige Fragen
        </h2>

        <div className="space-y-4" data-id="element-85">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-warmBrown/10 overflow-hidden shadow-sm" data-id="element-86">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-87">
                <span className="font-serif font-bold text-lg text-forestGreen pr-4" data-id="element-88">
                  {faq.q}
                </span>
                <ChevronDown className={`text-warmBrown/60 transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-89" />
              </button>

              <AnimatePresence data-id="element-90">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-91">
                    <div className="px-6 pb-6 pt-0 font-serif text-gray-700 leading-relaxed" data-id="element-92">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}